'use strict';


import HintTransition from './HintTransition';
import {addClass,removeClass} from './../lang';


export default class PseudoHintElement {
  /**
   *
   * @param {HTMLElement} el
   * @param {String} transition
   */
  constructor(el, transition) {
    this.transition = new HintTransition(transition);
    this.addClass = addClass.bind(this, el);
    this.removeClass = removeClass.bind(this, el);
  }
}


// WEBPACK FOOTER //
// ./src/js/classes/PseudoHintElement.js